const baseStyle = {
  fontSize: 'md',
  h: '84px',
  lineHeight: 'md',
  multiline: true,
  py: '0.5',
  textAlignVertical: 'top',
  _web: {
    h: '20',
    py: '1',
  },
};

export default {
  baseStyle,
  defaultProps: {
    size: 'sm',
    variant: 'outline',
  },
};
